import { createContext, useContext } from "react";
import type { Game } from "@engine/core/Game";
import type { SceneManager } from "./scenes/SceneManager";

export interface EngineContextValue {
  game: Game;
  scenes: SceneManager;
}

export const EngineContext = createContext<EngineContextValue | null>(null);

export const useEngine = (): EngineContextValue => {
  const ctx = useContext(EngineContext);
  if (!ctx) throw new Error("useEngine must be used inside <EngineHost>");
  return ctx;
};
